import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import logo from "../images/transparent-logo.png";
import { fetchViaPost } from "../helpers/fetchViaPost";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link
        color="inherit"
        href="https://betty.works/"
      >
        betty
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export function ForgotPassword({
  setAuth,
}) {
  const [loading, setLoading] =
    useState(false);

  const [submitted, setSubmitted] =
    useState(false);

  const [error, setError] =
    useState("");

  async function handleSubmit(event) {
    event.preventDefault();

    setLoading(true);
    setError("");

    const data =
      new FormData(
        event.currentTarget
      );

    try {
      const response =
        await fetchViaPost(
          "request-password-reset",
          JSON.stringify({
            email:
              data.get("email"),
          })
        );

      const result =
        await response.json();

      if (!result?.ok) {
        setError(
          "The request could not be processed. Please try again."
        );
        return;
      }

      setSubmitted(true);
    } catch (err) {
      console.error(
        "[Forgot Password]",
        err
      );

      setError(
        "The request could not be processed. Please try again."
      );
    } finally {
      setLoading(false);
    }
  }

  function backToSignIn() {
    if (setAuth) {
      setAuth("sign-in");
    }

    window.location.pathname =
      "sign-in";
  }

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Container
      component="main"
      maxWidth="xs"
    >
      <CssBaseline />

      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src={logo}
          alt="betty"
          style={{
            width: "10em",
          }}
        />

        <Typography
          component="h1"
          variant="h5"
        >
          Forgot password?
        </Typography>

        {!submitted ? (
          <Box
            component="form"
            onSubmit={handleSubmit}
            sx={{
              mt: 2,
              width: "100%",
            }}
          >
            <Typography
              color="text.secondary"
              sx={{
                mb: 2,
              }}
            >
              Enter the email address
              you use for betty.
            </Typography>

            {error && (
              <Alert
                severity="error"
                sx={{ mb: 2 }}
              >
                {error}
              </Alert>
            )}

            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 3,
                mb: 2,
              }}
            >
              Send reset link
            </Button>
          </Box>
        ) : (
          <Box
            sx={{
              mt: 3,
              width: "100%",
            }}
          >
            <Alert
              severity="success"
              sx={{
                mb: 2,
              }}
            >
              If an account exists
              for this email address,
              we have sent a password
              reset link.
            </Alert>

            <Typography
              color="text.secondary"
            >
              Please check your inbox.
              The reset link is valid
              for 30 minutes.
            </Typography>
          </Box>
        )}

        <Button
          onClick={backToSignIn}
          sx={{
            mt: 2,
          }}
        >
          Back to Sign In
        </Button>
      </Box>

      <Copyright
        sx={{
          mt: 8,
          mb: 4,
        }}
      />
    </Container>
  );
}
